export const LOCALITIES = [
  'Sacramento City',
  'Fair Oaks/Orangevale',
  'Rancho Cordova',
  'Folsom',
  'Citrus Heights',
  'Elk Grove',
  'Sacramento County Central',
  'Sacramento County Northwest',
  'Carmichael',
  'Galt',
]

// ── External resource URLs ──────────────────────────────────────────────────
export const CLUSTER_CALENDAR_URL =
  'https://docs.google.com/spreadsheets/d/1CrSXGIEnU_H7J9tfKS_fMHVEFXFNN3ivif3z5Qe8EVU/edit?gid=1100001616#gid=1100001616'
export const RUHI_ORDER_FORM_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLScdBs5KNlPJNBlbFE1zniRY67j5IHowrA_r3Fu1nEjV68y9iA/viewform'

export const RUHI_BOOKS = [
  { value: 1,  label: 'Book 1 — Reflections on the Life of the Spirit',  units: 3, sectionsPerUnit: [,9,11,23] },
  { value: 2,  label: 'Book 2 — Arising to Serve',                       units: 3, sectionsPerUnit: [,9,11,16] },
  { value: 3,  label: "Book 3 — Teaching Children's Classes",            units: 2, sectionsPerUnit: [,27,24] },
  { value: 4,  label: 'Book 4 — The Twin Manifestations',                units: 3, sectionsPerUnit: [,8,13,31] },
  { value: 5,  label: 'Book 5 — Releasing the Powers of Junior Youth',   units: 3, sectionsPerUnit: [,21,23,30] },
  { value: 6,  label: 'Book 6 — Teaching the Cause',                     units: 3, sectionsPerUnit: [,29,18,36] },
  { value: 7,  label: 'Book 7 — Walking Together on a Path of Service',  units: 3, sectionsPerUnit: [,11,38,13] },
  { value: 8,  label: "Book 8 — The Covenant of Bahá'u'lláh",            units: 3, sectionsPerUnit: [,44,49,43] },
  { value: 9,  label: 'Book 9 — Gaining an Historical Perspective',      units: 3, sectionsPerUnit: [,5,5,6] },
  { value: 10, label: 'Book 10 — Building Vibrant Communities',          units: 3, sectionsPerUnit: [,5,6,5] },
  { value: 11, label: 'Book 11 — Material Means',                        units: 3, sectionsPerUnit: [,4,5,6] },
  { value: 12, label: 'Book 12 — Portals to Growth',                     units: 3, sectionsPerUnit: [,5,5,5] },
  { value: 13, label: 'Book 13 — Learning About Growth',                 units: 3, sectionsPerUnit: [,5,5,5] },
  { value: 14, label: 'Book 14 — Participating in Social Action',        units: 3, sectionsPerUnit: [,5,5,5] },
]

export const JY_BOOKS = [
  { value: '1',  label: 'Book 1 — Breezes of Confirmation',              sections: 7  },
  { value: '2',  label: 'Book 2 — Glimmerings of Hope',                  sections: 8  },
  { value: '3',  label: 'Book 3 — Thinking About Numbers',               sections: 9  },
  { value: '4',  label: 'Book 4 — Reflection and Action',                sections: 7  },
  { value: '5',  label: 'Book 5 — Spirit of Faith',                      sections: 8  },
  { value: '6',  label: 'Book 6 — Learning About Excellence',            sections: 7  },
  { value: '7',  label: 'Book 7 — Walking the Straight Path',            sections: 8  },
  { value: '8',  label: 'Book 8 — The Tree of Life',                     sections: 7  },
  { value: '9',  label: 'Book 9 — The Human Soul',                       sections: 8  },
  { value: '10', label: 'Book 10 — Drawing on the Power of the Word',    sections: 7  },
  { value: '11', label: 'Book 11 — The Shining Lamp',                    sections: 8  },
  { value: '12', label: 'Book 12 — The Prosperity of Humankind',         sections: 7  },
  { value: '13', label: 'Book 13 — The Generations',                     sections: 8  },
  { value: '14', label: 'Book 14 — Open to the Promptings of the Heart', sections: 7  },
  { value: '15', label: 'Book 15 — In the Company of the Sincere',       sections: 8  },
]

export const CHILDRENS_GRADES = [
  { value: '1', label: 'Grade 1' },
  { value: '2', label: 'Grade 2' },
  { value: '3', label: 'Grade 3' },
  { value: '4', label: 'Grade 4' },
  { value: '5', label: 'Grade 5' },
]

export const CHILDRENS_LESSONS = { 1: 24, 2: 21, 3: 16, 4: 16, 5: 12 }

// ── Activity types — single source of truth ─────────────────────────────────
// Every activity-type string lives here so the metadata can't drift between the
// two activity edit modals (RecurringActivities.js's create/edit modal and
// ActivityDetail.js's edit modal) the way assistantLabel once did.
//
// Consumed two ways:
//   - ACTIVITY_TYPES (keyed by id, derived below) — label/emoji/assistantLabel
//     lookups across the app.
//   - RecurringActivities.js groups these via `group` for its create flow and
//     reads facilitatorLabel / assistantLabel / participantLabel for its pickers.
//
// `label` is the plural/category form shown in lists; `singularLabel` is the
// "Start a New X" form the create flow uses where it differs. `group` is
// 'core' | 'ongoing' | 'oneoff'; order within each group is the create-flow
// display order. assistantLabel here only controls the roster picker — the
// separate session-logging assistant gate is ASSISTANT_ACTIVITY_TYPES below.
export const ACTIVITY_TYPE_LIST = [
  // Core ongoing
  { id: 'A001', group: 'core',    label: "Children's Classes",    singularLabel: "Children's Class",  emoji: '🧒', facilitatorLabel: 'Teachers',     assistantLabel: 'Assistant Teachers', participantLabel: 'Children' },
  { id: 'A002', group: 'core',    label: 'Junior Youth Groups',   singularLabel: 'Junior Youth Group', emoji: '🌱', facilitatorLabel: 'Animators',    assistantLabel: 'Assistant Animators' },
  { id: 'A004', group: 'core',    label: 'Study Circles',         singularLabel: 'Study Circle',       emoji: '📖', facilitatorLabel: 'Tutors',       assistantLabel: 'Assistant Tutors' },
  { id: 'A005', group: 'core',    label: 'Devotional Gatherings', emoji: '🕯️', facilitatorLabel: 'Hosts' },
  // Other ongoing
  { id: 'E003', group: 'ongoing', label: 'Youth Night',           emoji: '🌙', facilitatorLabel: 'Hosts' },
  { id: 'A008', group: 'ongoing', label: 'Institute Day/Night',   emoji: '🏫', facilitatorLabel: 'Tutors' },
  { id: 'E002', group: 'ongoing', label: 'JY Camp',               emoji: '⛺', facilitatorLabel: 'Animators',    assistantLabel: 'Assistant Animators' },
  { id: 'E004', group: 'ongoing', label: 'Youth Camp',            emoji: '🏕️', facilitatorLabel: 'Tutors',      assistantLabel: 'Assistant Tutors' },
  { id: 'E001', group: 'ongoing', label: "Children's Festival",   emoji: '🎪', facilitatorLabel: 'Facilitators' },
  { id: 'E005', group: 'ongoing', label: 'Conference',            emoji: '🎓', facilitatorLabel: 'Facilitators', assistantLabel: 'Assistants' },
  { id: 'A009', group: 'ongoing', label: 'Meeting',               emoji: '🗓️', facilitatorLabel: 'Organizers' },
  // One-off events
  { id: 'A006', group: 'oneoff',  label: 'Home Visit',            emoji: '🏠', facilitatorLabel: 'Visitors', multiDay: false },
  { id: 'A007', group: 'oneoff',  label: 'Outreach',              emoji: '🤝', facilitatorLabel: 'Visitors', multiDay: false, hidden: true },
]

// Keyed lookup derived from the canonical list. Existing call sites read
// .label / .emoji / .assistantLabel exactly as before; the extra fields are
// harmless. No consumer depends on key order (Reimbursements re-sorts).
export const ACTIVITY_TYPES = Object.fromEntries(
  ACTIVITY_TYPE_LIST.map(t => [t.id, t])
)

// Activity types that support assistants
export const ASSISTANT_ACTIVITY_TYPES = new Set(['A001', 'A002', 'A004', 'E002', 'E004'])

// ── Registration form field templates ───────────────────────────────────────

export const SIGNIN_SHEET_FIELDS = [
  { name: 'adult_first_name', label: 'First Name', type: 'text', required: true, enabled: true },
  { name: 'adult_last_name',  label: 'Last Name',  type: 'text', required: true, enabled: true },
  { name: 'adult_phone',      label: 'Phone',      type: 'tel',  enabled: true },
  { name: 'adult_email',      label: 'Email',      type: 'email', enabled: true },
  { name: 'adult_address',    label: 'Address', type: 'text', enabled: true },
  { name: 'adult_sex',        label: 'Sex', type: 'select', options: ['M', 'F'], enabled: false },
  { name: 'learn_more',       label: "Would you like to learn more about children's classes in your area?", type: 'select', options: ['Yes', 'No'], enabled: true },
  { name: 'is_parent_guardian', label: 'I am the parent or guardian of the children listed below', type: 'checkbox', enabled: true },
  { name: 'children_section', label: 'Children (first name, last name, age)', type: 'group', enabled: true },
  { name: 'child_1_first_name', label: 'Child 1 First Name', type: 'text', enabled: true },
  { name: 'child_1_last_name',  label: 'Child 1 Last Name',  type: 'text', enabled: true },
  { name: 'child_1_age',        label: 'Child 1 Age', type: 'number', enabled: true },
  { name: 'child_1_sex',        label: 'Child 1 Sex', type: 'select', options: ['M', 'F'], enabled: false },
  { name: 'child_2_first_name', label: 'Child 2 First Name', type: 'text', enabled: true },
  { name: 'child_2_last_name',  label: 'Child 2 Last Name',  type: 'text', enabled: true },
  { name: 'child_2_age',        label: 'Child 2 Age', type: 'number', enabled: true },
  { name: 'child_2_sex',        label: 'Child 2 Sex', type: 'select', options: ['M', 'F'], enabled: false },
  { name: 'comments',         label: 'Comments or Questions', type: 'textarea', enabled: true },
]

export const CONFERENCE_FIELDS = [
  { name: 'first_name', label: 'First Name', required: true, enabled: true },
  { name: 'last_name', label: 'Last Name', required: true, enabled: true },
  { name: 'city', label: 'Locality', type: 'select', options: [], enabled: true },
  { name: 'age_range', label: 'Age Range', type: 'select', options: ['0-4','5-7','8-11','12-14','15-18','19-25','26+'], enabled: true },
  { name: 'email', label: 'Email', enabled: true },
  { name: 'phone', label: 'Phone', enabled: true },
  { name: 'food_preference', label: 'Food Preference', type: 'select', options: ['Vegetarian / Vegetariano / \u06AF\u06CC\u0627\u0647\u200C\u062E\u0648\u0627\u0631\u06CC','No restriction / Meat / \u06AF\u0648\u0634\u062A','Bringing my own food'], enabled: true },
  { name: 'language_preference', label: 'Language Preference', type: 'select', options: ['English','Farsi','Spanish'], enabled: true },
  { name: 'parent_guardian_name', label: 'Parent/Guardian Name', enabled: true, show_if: 'age_range_under_18' },
  { name: 'parent_guardian_phone', label: 'Parent/Guardian Phone', enabled: true, show_if: 'age_range_under_18' },
  { name: 'emergency_contact', label: 'Emergency Contact', enabled: true },
  { name: 'transportation_needed', label: 'Transportation Needed', type: 'select', options: ['No, I will arrange my own','Yes, I need help finding a carpool'], enabled: true, profile_field: false },
  { name: 'comments', label: 'Comments', type: 'textarea', enabled: true },
]

export const YOUTH_CONFERENCE_FIELDS = [
  { name: 'first_name', label: 'First Name', required: true, enabled: true },
  { name: 'last_name', label: 'Last Name', required: true, enabled: true },
  { name: 'city', label: 'Locality', type: 'select', options: [], enabled: true },
  { name: 'age_range', label: 'Age Range', type: 'select', options: ['15-18','19-25','26-29'], enabled: true },
  { name: 'email', label: 'Email', enabled: true },
  { name: 'phone', label: 'Phone', enabled: true },
  { name: 'birthdate', label: 'Birthdate', type: 'date', enabled: true },
  { name: 'ruhi_books_completed', label: 'Ruhi Books Completed', type: 'checklist', options: [
    'Book 1 \u2014 Reflections on the Life of the Spirit',
    'Book 2 \u2014 Arising to Serve',
    'Book 3 \u2014 Teaching Children\'s Classes',
    'Book 4 \u2014 The Twin Manifestations',
    'Book 5 \u2014 Releasing the Powers of Junior Youth',
    'Book 6 \u2014 Teaching the Cause',
    'Book 7 \u2014 Walking Together on a Path of Service',
    'Book 8 \u2014 The Covenant of Bah\u00e1\'u\'ll\u00e1h',
    'Book 9 \u2014 Gaining an Historical Perspective',
    'Book 10 \u2014 Building Vibrant Communities',
    'Book 11 \u2014 Material Means',
    'Book 12 \u2014 Portals to Growth',
    'Book 13 \u2014 Learning About Growth',
    'Book 14 \u2014 Participating in Social Action',
  ], enabled: true, books_1_7_always_shown: true, books_8_14_toggleable: true },
  { name: 'dietary_restrictions', label: 'Dietary Restrictions', type: 'select', options: ['None','Vegetarian','Vegan','Nut Allergy','Other'], enabled: true },
  { name: 'language_preference', label: 'Language Preference', type: 'select', options: ['English','Farsi','Spanish'], enabled: true },
  { name: 'transportation_needed', label: 'Transportation Needed', type: 'select', options: ['No, I will arrange my own','Yes, I need help finding a carpool'], enabled: true, profile_field: false },
  { name: 'parent_guardian_name', label: 'Parent/Guardian Name', enabled: true, show_if: 'age_range_15_18' },
  { name: 'parent_guardian_phone', label: 'Parent/Guardian Phone', enabled: true, show_if: 'age_range_15_18' },
  { name: 'parent_guardian_email', label: 'Parent/Guardian Email', enabled: true, show_if: 'age_range_15_18' },
  { name: 'emergency_contact', label: 'Emergency Contact', enabled: true },
  { name: 'comments', label: 'Comments', type: 'textarea', enabled: true },
]

export const INSTITUTE_CAMP_FIELDS = [
  { name: 'first_name', label: 'First Name', required: true, enabled: true },
  { name: 'last_name', label: 'Last Name', required: true, enabled: true },
  { name: 'email', label: 'Email', enabled: true },
  { name: 'phone', label: 'Phone', enabled: true },
  { name: 'camp_dates', label: 'Camp Dates', type: 'select', options: [], enabled: true },
  { name: 'current_ruhi_book', label: 'Current Ruhi Book', type: 'text', enabled: true },
  { name: 'participation_level', label: 'Participation Level', type: 'select', options: ['Full duration \u2014 sleepover','Full duration \u2014 commute daily','Partial attendance'], enabled: true },
  { name: 'dietary_restrictions', label: 'Dietary Restrictions', type: 'select', options: ['None','Vegetarian','Vegan','Gluten-free','Other'], enabled: true },
  { name: 'parent_guardian_note', label: 'Parent/Guardian Note', type: 'textarea', enabled: true, show_if: 'minor' },
  { name: 'emergency_contact', label: 'Emergency Contact', enabled: true },
  { name: 'comments', label: 'Comments', type: 'textarea', enabled: true },
]

export const JY_CAMP_FIELDS = [
  { name: 'first_name', label: 'First Name', required: true, enabled: true },
  { name: 'last_name', label: 'Last Name', required: true, enabled: true },
  { name: 'email', label: 'Email', enabled: true },
  { name: 'phone', label: 'Phone', enabled: true },
  { name: 'camp_dates', label: 'Camp Dates', type: 'select', options: [], enabled: true },
  { name: 'current_jy_book', label: 'Current JY Book', type: 'text', enabled: true },
  { name: 'participation_level', label: 'Participation Level', type: 'select', options: ['Full duration \u2014 sleepover','Full duration \u2014 commute daily','Partial attendance'], enabled: true },
  { name: 'dietary_restrictions', label: 'Dietary Restrictions', type: 'select', options: ['None','Vegetarian','Vegan','Gluten-free','Other'], enabled: true },
  { name: 'parent_guardian_name', label: 'Parent/Guardian Name', required: true, enabled: true },
  { name: 'parent_guardian_phone', label: 'Parent/Guardian Phone', required: true, enabled: true },
  { name: 'parent_guardian_email', label: 'Parent/Guardian Email', enabled: true },
  { name: 'emergency_contact', label: 'Emergency Contact', required: true, enabled: true },
  { name: 'comments', label: 'Comments', type: 'textarea', enabled: true },
]

export const YOUTH_NIGHT_FIELDS = [
  { name: 'first_name', label: 'First Name', required: true, enabled: true },
  { name: 'last_name', label: 'Last Name', required: true, enabled: true },
  { name: 'age', label: 'Age', type: 'number', enabled: true },
  { name: 'phone', label: 'Phone', enabled: true },
  { name: 'email', label: 'Email', enabled: true },
  { name: 'food_preference', label: 'Food Preference', type: 'select', options: ['Vegetarian','No restriction / Meat','Bringing my own food'], enabled: true },
]

export function getDefaultFieldsForType(activityType, subType) {
  if (activityType === 'E001') return SIGNIN_SHEET_FIELDS
  if (activityType === 'E002') return JY_CAMP_FIELDS
  if (activityType === 'E003') return YOUTH_NIGHT_FIELDS
  if (activityType === 'E004') return INSTITUTE_CAMP_FIELDS
  if (activityType === 'E005') {
    return subType === 'youth_conference' ? YOUTH_CONFERENCE_FIELDS : CONFERENCE_FIELDS
  }
  return []
}
